import {
  CREATE_DODO_PAYMENT_URL_FAILED,
  CREATE_DODO_PAYMENT_URL_REQUEST,
  CREATE_DODO_PAYMENT_URL_SUCCESS,
  GET_PAYMENT_INFO_FAILED,
  GET_PAYMENT_INFO_REQUEST,
  GET_PAYMENT_INFO_SUCCESS,
} from "../../constants/Payment/paymentConstants";

export const paymentCreateDodoUrlReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_DODO_PAYMENT_URL_REQUEST:
      return {
        loading: true,
      };
    case CREATE_DODO_PAYMENT_URL_SUCCESS:
      return {
        loading: false,
        dodoData: action.payload,
      };
    case CREATE_DODO_PAYMENT_URL_FAILED:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const getPaymentInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PAYMENT_INFO_REQUEST:
      return {
        loading: true,
      };
    case GET_PAYMENT_INFO_SUCCESS:
      return {
        loading: false,
        paymentData: action.payload,
      };
    case GET_PAYMENT_INFO_FAILED:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
